import { useAutoUpdate } from '/app/composables/app';
import { defineAppRouteMiddleware } from '/app/utils/app';
import { shouldSkipAppUpdateForNavigation } from '/app/utils/app-update';

const { tryUpdate: tryUpdateApp } = useAutoUpdate();

export default defineAppRouteMiddleware((to, from) => {
    if (!shouldSkipAppUpdateForNavigation(to, from)) {
        tryUpdateApp();
    }
})
